export const inspectTable = [
  {
    content: "건축물이나 설비의 철거·해체 시 석면조사 (법 제119조)",
    isChecked: "",
  },
  {
    content: "석면해제·제거업자를 통한 석면의 해체·제거 (법 제122조)",
    isChecked: "",
  },
  {
    content: "석면작업기준, 석면농도기준의 준수 (법 제123조, 제124조)",
    isChecked: "",
  },
];
